
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_17pk4_186",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_17pk4_192",
  "pagination-button": "awsui_pagination-button_14rmt_17pk4_207",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_17pk4_212",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_17pk4_215",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_17pk4_219",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_17pk4_222",
  "tabs-tab": "awsui_tabs-tab_14rmt_17pk4_227",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_17pk4_238",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_17pk4_254",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_17pk4_313",
  "refresh": "awsui_refresh_14rmt_17pk4_331",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_17pk4_345",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_17pk4_352",
  "root": "awsui_root_14rmt_17pk4_356",
  "tabs": "awsui_tabs_14rmt_17pk4_186",
  "tabs-content": "awsui_tabs-content_14rmt_17pk4_375",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_17pk4_379",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_17pk4_389",
  "with-paddings": "awsui_with-paddings_14rmt_17pk4_389",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_17pk4_393"
};
  